/**
 * Знімає кадр із відео співрозмовника для скарги. Повертає JPEG у base64 без
 * префікса data:. Кадр надсилається лише разом зі скаргою, автоматично нічого не
 * збирається.
 */
export function captureFrame(video: HTMLVideoElement | null, maxWidth = 480, quality = 0.6): string | undefined {
  if (!video || !video.videoWidth || !video.videoHeight) return undefined;
  const scale = Math.min(1, maxWidth / video.videoWidth);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(video.videoWidth * scale);
  canvas.height = Math.round(video.videoHeight * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) return undefined;
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  const url = canvas.toDataURL('image/jpeg', quality);
  const comma = url.indexOf(',');
  return comma > 0 ? url.slice(comma + 1) : undefined;
}
